import type { CampaignSettlement } from "@/marketing/models/campaignSettlement";

// Marketing's affiliate payout floor. The backend settles any confirmed amount, so the only place the
// floor can hold is here, where an admin marks the row paid after sending the money. An unpaid
// commission row keeps accruing on the next commission run, so leaving it open is the carry-over.
export const COMMISSION_MINIMUM_PAYOUT_USD = 20;

type SettlementPayoutFields = Pick<CampaignSettlement, "kind" | "amount">;

export function isBelowCommissionPayoutMinimum(
  settlement: SettlementPayoutFields | null,
): boolean {
  if (settlement?.kind !== "commission") return false;
  const amount = Number(settlement.amount?.trim() || 0);
  return !Number.isFinite(amount) || amount < COMMISSION_MINIMUM_PAYOUT_USD;
}
